import classNames from 'classnames';
import { Separator } from 'react-resizable-panels';
import './NSResizeHandle.scss';

interface INSResizeHandleProps {
    orientation?: 'horizontal' | 'vertical';
    className?: string;
}

const NSResizeHandle = ({ orientation = 'horizontal', className }: INSResizeHandleProps) => (
    <Separator
        className={classNames('NSResizeHandle', `NSResizeHandle--${orientation}`, 'text-muted hover:text-gray-600', className)}
    />
);

export default NSResizeHandle;
